import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import { kRouteSegments } from '@/routing/paths'
import { kDraftSearchParam } from '@/drafting/workspace/hooks/useDraftWorkspace'

const kV1DraftSearchParam = 'artifactVersionId'

/** Translate the draft deep link while retaining unrelated query parameters. */
export function translateV1DraftSearchParam(url: URL): void {
  const versionId = url.searchParams.get(kV1DraftSearchParam)
  if (versionId === null) return
  url.searchParams.set(kDraftSearchParam, versionId)
  url.searchParams.delete(kV1DraftSearchParam)
}

/**
 * Redirects matter-scoped legacy chat features to Agent V2.
 *
 * Example: /dashboard/m/:matterId/chat/drafting/... → /dashboard/m/:matterId/chat/agent/...
 */
export function redirectAliasedChatFeatureRoute({ params, request }: LoaderFunctionArgs): Response | null {
  const originalFeature = params.chatFeature

  if (originalFeature === kRouteSegments.agentV2) return null

  const url = new URL(request.url)
  translateV1DraftSearchParam(url)
  const destinationPath = url.pathname.replace(`/chat/${originalFeature}`, `/chat/${kRouteSegments.agentV2}`)
  return redirect(`${destinationPath}${url.search}`)
}
